import {
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
} from '@mui/material';
import { useRootStore } from '../../../../stores/rootStore';

const HOUSEHOLD_COMPOSITION_METRICS_AU = [
  {
    groupMetricId: '107',
    metricId: '1115',
    displayName: 'Household Composition: Childless Couples',
    definition:
      'The percentage of Childless Couples households for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1116',
    displayName: 'Household Composition: Couples with Children',
    definition:
      'The percentage of Couples with Children households for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1117',
    displayName: 'Household Composition: Single Parents',
    definition:
      'The percentage of Single Parent households for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1118',
    displayName: 'Household Composition: Lone Households',
    definition: 'The percentage of Lone households for the geographical area.',
  },
  {
    metricId: '1119',
    displayName: 'Household Composition: Group Households',
    definition: 'The percentage of Group households for the geographical area.',
  },
  {
    metricId: '1120',
    displayName: 'Household Composition: Other',
    definition:
      'The percentage of Other households for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const ANNUAL_HOUSEHOLD_INCOME_METRICS_AU = [
  {
    groupMetricId: '105',
    metricId: '1319',
    displayName: 'Household Income: 0-13K',
    definition:
      'TThe percentage of households with a yearly income that falls within the 0-13K range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1096',
    displayName: 'Household Income: 13-26K',
    definition:
      'The percentage of households with a yearly income that falls within the 13-26K range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1097',
    displayName: 'Household Income: 26-33.8K',
    definition:
      'The percentage of households with a yearly income that falls within the 26-33.8K range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1098',
    displayName: 'Household Income: 33.8-52K',
    definition:
      'The percentage of households with a yearly income that falls within the 33.8-52K range for the geographical area. This metric is available in 2006, 2016, 2021.',
  },
  {
    metricId: '1099',
    displayName: 'Household Income: 52-72.8K',
    definition:
      'The percentage of households with a yearly income that falls within the 52-72.8K range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1100',
    displayName: 'Household Income: 72.8-104K',
    definition:
      'The percentage of households with a yearly income that falls within the 72.8-104K range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1101',
    displayName: 'Household Income: 104K+',
    definition:
      'The percentage of households with a yearly income that is 104K and over for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1102',
    displayName: 'Household Income: 0-15.6K',
    definition:
      'The percentage of households with a yearly income that falls within the 0-15.6K range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1320',
    displayName: 'Household Income: 15.6-33.8K',
    definition:
      'The percentage of households with a yearly income that falls within the 15.6-33.8K range for the geographical area. This metric is available in 2016, 2021.',
  },
  {
    metricId: '1103',
    displayName: 'Household Income: 15.6-31.2K',
    definition:
      'The percentage of households with a yearly income that falls within the 15.6-31.2K range for the geographical area. This metric is available in 2011.',
  },
  {
    metricId: '1104',
    displayName: 'Household Income: 31.2-52K',
    definition:
      'The percentage of households with a yearly income that falls within the 31.2-52K range for the geographical area. This metric is available in 2011.',
  },
  {
    metricId: '1105',
    displayName: 'Household Income: 52-78K',
    definition:
      'The percentage of households with a yearly income that falls within the 52-78k range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1106',
    displayName: 'Household Income: 78-130K',
    definition:
      'The percentage of households with a yearly income that falls within the 78-130k range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1107',
    displayName: 'Household Income: 130-182K',
    definition:
      'The percentage of households with a yearly income that falls within the 130-182K range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1108',
    displayName: 'Household Income: 182K+',
    definition:
      'The percentage of households with a yearly income that is 182K and over for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
];

const WEEKLY_HOUSEHOLD_INCOME_METRICS_AU = [
  {
    groupMetricId: '122',
    metricId: '1323',
    displayName: 'Household Income: $1-$149',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2016, 2021.',
  },
  {
    metricId: '1324',
    displayName: 'Household Income: $150-$249',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1325',
    displayName: 'Household Income: $250-$349',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1326',
    displayName: 'Household Income: $350-$499',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1327',
    displayName: 'Household Income: $500-$649',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2016, 2021',
  },
  {
    metricId: '1328',
    displayName: 'Household Income: $650-$799',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2016, 2021',
  },
  {
    metricId: '1329',
    displayName: 'Household Income: $800-$999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    metricId: '1330',
    displayName: 'Household Income: $1000-$1199',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1331',
    displayName: 'Household Income: $1200-$1399',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1332',
    displayName: 'Household Income: $1400-$1699',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1333',
    displayName: 'Household Income: $1700-$1999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1334',
    displayName: 'Household Income: $2000-$2499',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    metricId: '1335',
    displayName: 'Household Income: $2500-$2999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    metricId: '1336',
    displayName: 'Household Income: $3000+',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006',
  },
  {
    metricId: '1337',
    displayName: 'Household Income: $1-$199',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011',
  },
  {
    metricId: '1338',
    displayName: 'Household Income: $200-$299',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011',
  },
  {
    metricId: '1339',
    displayName: 'Household Income: $300-$399',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1340',
    displayName: 'Household Income: $400-$599',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011',
  },
  {
    metricId: '1341',
    displayName: 'Household Income: $600-$799',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011',
  },
  {
    metricId: '1342',
    displayName: 'Household Income: $1000-$1249',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1343',
    displayName: 'Household Income: $1250-$1499',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1344',
    displayName: 'Household Income: $1500-$1999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011',
  },
  {
    metricId: '1345',
    displayName: 'Household Income: $3000-$3499',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1346',
    displayName: 'Household Income: $3500-$3999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1347',
    displayName: 'Household Income: $4000+',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2011, 2016, 2021',
  },
  {
    metricId: '1348',
    displayName: 'Household Income: $150-$299',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2016, 2021',
  },
  {
    metricId: '1349',
    displayName: 'Household Income: $400-$499',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2016, 2021',
  },
  {
    metricId: '1350',
    displayName: 'Household Income: $1500-$1749',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2016, 2021',
  },
  {
    metricId: '1351',
    displayName: 'Household Income: $1750-$1999',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2016, 2021',
  },
  {
    metricId: '1352',
    displayName: 'Household Income: Nil',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    metricId: '1353',
    displayName: 'Household Income: Not Stated',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
  {
    metricId: '1354',
    displayName: 'Household Income: Partial Stated',
    definition:
      'The percentage of households with a weekly income that falls within the given range for the geographical area. This metric is available in 2006, 2011, 2016, 2021',
  },
];

const HOUSEHOLD_OCCUPANCY_METRICS_AU = [
  {
    groupMetricId: '106',
    metricId: '1110',
    displayName: 'Tenure: Renting',
    definition:
      'The percentage of households where the occupant is renting for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1111',
    displayName: 'Tenure: Owns Outright',
    definition:
      'The percentage of households where the occupant owns the property outright for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1112',
    displayName: 'Tenure: Purchaser',
    definition:
      'The percentage of households where the occupant is the purchaser for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1113',
    displayName: 'Tenure: Other',
    definition:
      'The percentage of households where the occupant is other for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1300',
    displayName: 'Tenure: Not Stated',
    definition:
      'The percentage of households where the occupant is not stated for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const MORTGAGE_REPAYMENT_METRICS_AU = [
  {
    groupMetricId: '108',
    metricId: '1122',
    displayName: 'Mortgage Repayment: Under $250',
    definition:
      'The percentage of households with a monthly mortgage repayment that is under $250 for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1123',
    displayName: 'Mortgage Repayment: $250 - $399',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $250 - $399 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1124',
    displayName: 'Mortgage Repayment: $400 - $549',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $400 - $549 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1125',
    displayName: 'Mortgage Repayment: $550 - $749',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $550 - $749 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1126',
    displayName: 'Mortgage Repayment: $750 - $949',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $750 - $949 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1127',
    displayName: 'Mortgage Repayment: $950 - $1199',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $950 - $1199 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1128',
    displayName: 'Mortgage Repayment: $1200 - $1399',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1200 - $1399 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1129',
    displayName: 'Mortgage Repayment: $1400 - $1599',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1400 - $1599 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1130',
    displayName: 'Mortgage Repayment: $1600 - $1999',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1600 - $1999 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1131',
    displayName: 'Mortgage Repayment: $2000 - $2999',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $2000 - $2999 range for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1132',
    displayName: 'Mortgage Repayment: Over $3000',
    definition:
      'The percentage of households with a monthly mortgage repayments that is Over $3000 for the geographical area. This metric is available in 2006.',
  },
  {
    metricId: '1134',
    displayName: 'Mortgage Repayment: Under $300',
    definition:
      'The percentage of households with a monthly mortgage repayments that is under $300 for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1135',
    displayName: 'Mortgage Repayment: $300 - $449',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $300 - $449 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1136',
    displayName: 'Mortgage Repayment: $450 - $599',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $450 - $599 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1137',
    displayName: 'Mortgage Repayment: $600 - $799',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $600 - $799 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1138',
    displayName: 'Mortgage Repayment: $800 - $999',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $800 - $999 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1139',
    displayName: 'Mortgage Repayment: $1000 - $1399',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1000 - $1399 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1140',
    displayName: 'Mortgage Repayment: $1400 - $1799',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1400 - $1799 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1141',
    displayName: 'Mortgage Repayment: $1800 - $2399',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $1800 - $2399 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1142',
    displayName: 'Mortgage Repayment: $2400 - $2999',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $2400 - $2999 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1143',
    displayName: 'Mortgage Repayment: $3000 - $3999',
    definition:
      'The percentage of households with a monthly mortgage repayments that falls within the $3000 - $3999 range for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1144',
    displayName: 'Mortgage Repayment: Over $4000',
    definition:
      'The percentage of households with a monthly mortgage repayments that is Over $4000 for the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1145',
    displayName: 'Mortgage Repayment: Not Stated',
    definition:
      'The percentage of households with a monthly mortgage repayments that is Not Stated for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const PROPERTY_TYPE_METRICS_AU = [
  {
    groupMetricId: '109',
    metricId: '1147',
    displayName: 'Property Type: House',
    definition:
      'The percentage of Houses in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1148',
    displayName: 'Property Type: Semi Detached',
    definition:
      'The percentage of Semi Detached properties in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1149',
    displayName: 'Property Type: Flat Unit or Apartment',
    definition:
      'The percentage of Flats, Units or Apartments in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1150',
    displayName: 'Property Type: Unoccupied',
    definition:
      'The percentage of Unoccupied properties in the geographical area. This metric is available in 2011, 2016, 2021.',
  },
  {
    metricId: '1151',
    displayName: 'Property Type: Other',
    definition:
      'The percentage of Other property types in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1301',
    displayName: 'Property Type: Not Stated',
    definition:
      'The percentage of unstated property types in the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const VEHICLES_PER_HOUSEHOLD_METRICS_AU = [
  {
    groupMetricId: '101',
    metricId: '1041',
    displayName: 'Vehicles per Household: none',
    definition:
      'The percentage of 0 vehicles per household for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1042',
    displayName: 'Vehicles per Household: 1',
    definition:
      'The percentage of 1 vehicle per household for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1043',
    displayName: 'Vehicles per Household: 2',
    definition:
      'The percentage of 2 vehicles per household for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1044',
    displayName: 'Vehicles per Household: 3',
    definition:
      'The percentage of 3 vehicles per household for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
  {
    metricId: '1278',
    displayName: 'Vehicles per Household: 4+',
    definition:
      'The percentage of 4 or more vehicles per household for the geographical area. This metric is available in 2006, 2011, 2016, 2021.',
  },
];

const HOUSEHOLD_INCOME_METRICS_NZ = [
  {
    groupMetricId: '117',
    metricId: '1231',
    displayName: 'Household Income: $20,000 or less',
    definition:
      'The percentage of households with an income that is below 20k for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1232',
    displayName: 'Household Income: $20,001-$30,000',
    definition:
      'The percentage of households with an income that falls within the 20-30k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1233',
    displayName: 'Household Income: $30,001-$50,000',
    definition:
      'The percentage of households with an income that falls within the 30-50k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1234',
    displayName: 'Household Income: $50,001-$70,000',
    definition:
      'The percentage of households with an income that falls within the 50-70k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1235',
    displayName: 'Household Income: $70,001-$100,000',
    definition:
      'The percentage of households with an income that falls within the 70-100k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1236',
    displayName: 'Household Income: $100,001-$150,000',
    definition:
      'The percentage of households with an income that falls within the 100-150k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1418',
    displayName: 'Household Income: $150,001-$200,000',
    definition:
      'The percentage of households with an income that falls within the 150-200k range for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1419',
    displayName: 'Household Income: $200,001 or more',
    definition:
      'The percentage of households with an income that is 200K and over for the geographical area. This metric is available for 2023.',
  },
];

const HOUSEHOLD_STRUCTURE_METRICS_NZ = [
  {
    groupMetricId: '118',
    metricId: '1238',
    displayName:
      'Household Structure: One-family household (with or without other people)',
    definition:
      'The percentage of single family households for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1239',
    displayName:
      'Household Structure: Two-family household (with or without other people)',
    definition:
      'The percentage of 2 family households for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1240',
    displayName:
      'Household Structure: Three-or-more family household (with or without other people)',
    definition:
      'The percentage of 3 or more family households for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1241',
    displayName:
      'Household Structure: One-person household with one usual resident',
    definition:
      'The percentage of One person household for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1243',
    displayName: 'Household Structure: Other multi-person household',
    definition:
      'The percentage of Other multi person households for the geographical area. This metric is available for 2023.',
  },
  {
    metricId: '1420',
    displayName: 'Household Structure: Household composition unidentifiable',
    definition:
      'The percentage of unidentifiable households for the geographical area. This metric is available for 2023.',
  },
];

export const HouseholdMetrics = () => {
  const country = useRootStore(state => state.country);

  const metrics = [
    {
      title: 'Household Composition',
      data: country === 'au' ? HOUSEHOLD_COMPOSITION_METRICS_AU : [],
    },
    {
      title: 'Annual Household Income',
      data: country === 'au' ? ANNUAL_HOUSEHOLD_INCOME_METRICS_AU : [],
    },
    {
      title: 'Weekly Household Income',
      data: country === 'au' ? WEEKLY_HOUSEHOLD_INCOME_METRICS_AU : [],
    },
    {
      title: 'Household Occupancy (Tenure)',
      data: country === 'au' ? HOUSEHOLD_OCCUPANCY_METRICS_AU : [],
    },
    {
      title: 'Mortgage Repayment',
      data: country === 'au' ? MORTGAGE_REPAYMENT_METRICS_AU : [],
    },
    {
      title: 'Property Type',
      data: country === 'au' ? PROPERTY_TYPE_METRICS_AU : [],
    },
    {
      title: 'Vehicles per Household',
      data: country === 'au' ? VEHICLES_PER_HOUSEHOLD_METRICS_AU : [],
    },
    {
      title: 'Household Income',
      data: country === 'au' ? [] : HOUSEHOLD_INCOME_METRICS_NZ,
    },
    {
      title: 'Household Structure',
      data: country === 'au' ? [] : HOUSEHOLD_STRUCTURE_METRICS_NZ,
    },
  ];

  return (
    <div>
      <Typography id="household-metrics" variant="h6" fontWeight={600} my={0.5}>
        Household Metrics
      </Typography>

      <Typography variant="body2">
        The Household Metrics relate to Household Composition, Income, Mortgage
        Repayments, Number of Vehicles, Occupancy, and Property Types for a
        particular location.
      </Typography>

      <br />

      <Stack gap={4}>
        {metrics
          .filter(metric => metric.data.length > 0)
          .map(metric => (
            <div>
              <Typography variant="body2" fontWeight={600}>
                {metric.title}
              </Typography>

              <br />

              <TableContainer component={Paper}>
                <Table>
                  <TableHead sx={{ whiteSpace: 'nowrap' }}>
                    <TableRow>
                      <TableCell>Group Metric ID</TableCell>
                      <TableCell>Metric ID</TableCell>
                      <TableCell>Display Name</TableCell>
                      <TableCell>Definition</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {metric.data.map(data => (
                      <TableRow key={data.metricId}>
                        {data.groupMetricId && (
                          <TableCell rowSpan={metric.data.length}>
                            {data.groupMetricId}
                          </TableCell>
                        )}
                        <TableCell>{data.metricId}</TableCell>
                        <TableCell>{data.displayName}</TableCell>
                        <TableCell>{data.definition}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ))}
      </Stack>
    </div>
  );
};
